import { render, staticRenderFns } from "./iconShield.vue?vue&type=template&id=19beaf99"
import script from "./iconShield.vue?vue&type=script&lang=js"
export * from "./iconShield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports